import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=6d34ee40"
import script from "./TableControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableControls.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports